/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CheckboxMultiSelect from './CheckboxMultiSelect';

/**
 * Drop-in replacement for @kenshooui/react-multi-select.
 * Maintains the same external API (items with {id, label, group?}, selectedItems, onChange).
 */
const ArpMultiSelect = ({
  items = [],
  selectedItems = [],
  onChange = () => {},
  className,
  withGrouping = false,
  itemRenderer,
  itemHeight = 40,
  showSearch = true,
  showSelectAll = true,
  showSelectedItems = true,
}) => (
  <div className={className}>
    <CheckboxMultiSelect
      items={items}
      selectedItems={selectedItems}
      onChange={onChange}
      withGrouping={withGrouping}
      itemRenderer={itemRenderer}
      itemHeight={itemHeight}
      showSearch={showSearch}
      showSelectAll={showSelectAll}
      showSelectedItems={showSelectedItems}
    />
  </div>
);

ArpMultiSelect.propTypes = {
  items: PropTypes.array,
  selectedItems: PropTypes.array,
  onChange: PropTypes.func,
  withGrouping: PropTypes.bool,
  itemRenderer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  itemHeight: PropTypes.number,
  showSearch: PropTypes.bool,
  showSelectAll: PropTypes.bool,
  showSelectedItems: PropTypes.bool,
  className: PropTypes.string,
};

export default ArpMultiSelect;
